import script from "./RemitToBankDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./RemitToBankDropdown.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__